import log from './log.js';
import configService from './services/amp-config.js';
import config from './config.js';
var ampConfig = null;

var fetchConfig = function fetchConfig() {
  if (ampConfig) {
    return Promise.resolve(ampConfig);
  } else {
    return configService.fetchAmpConfig().then(function (config) {
      ampConfig = config;
      return ampConfig;
    });
  }
};

var get = function get(name) {
  // windows not available when used as a back-end services.
  if (typeof window !== 'undefined') {
    var storedConfig = window.localStorage.getItem("ampConfig.".concat(name));

    if (storedConfig !== null) {
      return Promise.resolve(storedConfig);
    }
  } // the requested value is overwritten, just return that.


  var overrideValue = config.get(name);

  if (overrideValue !== undefined) {
    return Promise.resolve(overrideValue);
  }

  return fetchConfig().then(function (config) {
    if (config[name]) {
      return config[name];
    } else {
      log.error("amp-config does not contain \"".concat(name, "\""));
    }
  });
};

export default {
  get: get
};